import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Constants} from '../../common/constants';
import {FieldConfigName} from '../../../models';
import {ControlDialogOptionsHelper} from '../control-dialog-options-helper';
import {TypeAvis} from '../../../../../enum/type-avis';

@Component({
  selector: 'app-avis-input-dialog',
  templateUrl: './avis-input-dialog.component.html'
})
export class AvisInputDialogComponent extends ControlDialogOptionsHelper implements OnInit {
  constants: any = Constants;
  editAvisInputForm: UntypedFormGroup;
  status: boolean;
  control: FieldConfigName;
  typeAvis = TypeAvis;

  constructor(private formBuilder: UntypedFormBuilder,
              public dialogRef: MatDialogRef<AvisInputDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    if (data) {
      this.control = data.control || this.control;
    }
  }

  ngOnInit(): void {
    this.validateFormBuilder();
    this.editProperty(this.control);
  }

  validateFormBuilder(): void {
    this.editAvisInputForm = this.formBuilder.group({
      tooltip: ['', []],
      label: ['', []],
      placeholder: ['', []],
      isRequired: [false],
      typeAvis: [TypeAvis.public, []],
    });
  }

  editProperty(control: any): void {
    this.status = control.options.isRequired;
    this.editAvisInputForm.setValue({
      tooltip: control.options.tooltip || '',
      label: control.options.label,
      placeholder: control.options.placeholder || '',
      isRequired: control.options.isRequired,
      typeAvis: control.options.typeAvis || TypeAvis.public,
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.editAvisInputForm.invalid) {
      return;
    }
    this.dialogRef.close(this.editAvisInputForm.value);
  }

  onChange(event: any): void {
    this.status = !!event.checked;
  }
}
